/**
 * Quick Add Inline — Wituka
 * Desktop (hover): banda con AÑADIR + tallas aparece en hover sobre la card.
 * Mobile (sin hover): botón "+" sobre la imagen abre un bottom sheet global
 *   con las tallas (estilo Eme Studios). El sheet sube desde abajo del viewport.
 * v: 2026-07-16b (color-aware quick-add + rebuild al cambiar swatch)
 */
(function () {
  if (window.__quickAddInlineBound) return;
  window.__quickAddInlineBound = true;

  /* ─── Reposicionar trigger + banda dentro de .card__inner ─────────────── */
  function repositionWithin(root) {
    var scope = root || document;
    var pieces = scope.querySelectorAll('.quick-add-inline, .quick-add-inline__trigger');
    pieces.forEach(function (el) {
      if (el.dataset.qaiPlaced === '1') return;
      // Si ya está en el sheet, no reposicionar
      if (el.closest('#qai-sheet')) return;
      var wrapper = el.closest('.card-wrapper');
      if (!wrapper) return;
      var inner = wrapper.querySelector('.card__inner');
      if (!inner) return;
      if (el.parentElement !== inner) inner.appendChild(el);
      el.dataset.qaiPlaced = '1';
    });
  }

  /* ─── Bottom sheet global (mobile) ────────────────────────────────────── */
  var sheet = null;
  var backdrop = null;
  var openedFromCard = null;
  var originalParent = null;

  function ensureSheet() {
    if (sheet) return;
    backdrop = document.createElement('div');
    backdrop.id = 'qai-sheet-backdrop';
    document.body.appendChild(backdrop);

    sheet = document.createElement('div');
    sheet.id = 'qai-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-hidden', 'true');
    document.body.appendChild(sheet);

    // Click en el backdrop → cerrar
    backdrop.addEventListener('click', closeSheet);

    // Click en el sheet (zona vacía, no en una talla) → cerrar
    sheet.addEventListener('click', function (e) {
      // Sólo cerrar si el click es en el propio sheet (no en sus hijos
      // interactivos como las tallas)
      if (e.target === sheet) closeSheet();
    });

    // Swipe-down (drag down) para cerrar
    bindSwipeDown(sheet);
  }

  /* ─── Swipe-down to dismiss ────────────────────────────────────────────── */
  function bindSwipeDown(el) {
    var startY = null;
    var currentY = null;
    var dragging = false;
    var SWIPE_THRESHOLD = 80; // px para considerar cierre

    function onStart(e) {
      var touch = e.touches ? e.touches[0] : e;
      startY = touch.clientY;
      currentY = startY;
      dragging = false;
      // Sólo permitir drag si el sheet está scrollado al top
      if (el.scrollTop > 0) startY = null;
    }

    function onMove(e) {
      if (startY === null) return;
      var touch = e.touches ? e.touches[0] : e;
      currentY = touch.clientY;
      var dy = currentY - startY;
      if (dy <= 0) {
        // Movimiento hacia arriba: ignorar
        if (dragging) {
          el.style.transform = '';
          dragging = false;
        }
        return;
      }
      dragging = true;
      el.style.transition = 'none';
      el.style.transform = 'translateY(' + dy + 'px)';
    }

    function onEnd() {
      if (startY === null) return;
      var dy = (currentY || startY) - startY;
      el.style.transition = '';
      if (dragging && dy > SWIPE_THRESHOLD) {
        // Cierre confirmado
        el.style.transform = '';
        closeSheet();
      } else {
        // Snap back
        el.style.transform = '';
      }
      startY = null;
      currentY = null;
      dragging = false;
    }

    el.addEventListener('touchstart', onStart, { passive: true });
    el.addEventListener('touchmove', onMove, { passive: true });
    el.addEventListener('touchend', onEnd);
    el.addEventListener('touchcancel', onEnd);
  }

  function openSheet(trigger) {
    ensureSheet();
    var card = trigger.closest('.card-wrapper');
    if (!card) return;
    var panel = card.querySelector('.quick-add-inline');
    if (!panel) return;

    // Si ya hay un sheet abierto, devolver su panel a su card original primero
    if (openedFromCard && openedFromCard !== card) {
      restorePanelFromSheet();
    }

    originalParent = panel.parentElement;
    sheet.appendChild(panel);
    openedFromCard = card;

    card.classList.add('is-quick-add-open');
    var t = card.querySelector('.quick-add-inline__trigger');
    if (t) t.setAttribute('aria-expanded', 'true');

    document.body.classList.add('qai-sheet-active');
    sheet.setAttribute('aria-hidden', 'false');
  }

  function restorePanelFromSheet() {
    if (!sheet) return;
    var panel = sheet.querySelector('.quick-add-inline');
    if (panel && originalParent) {
      originalParent.appendChild(panel);
    }
    if (openedFromCard) {
      openedFromCard.classList.remove('is-quick-add-open');
      var t = openedFromCard.querySelector('.quick-add-inline__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
    openedFromCard = null;
    originalParent = null;
  }

  function closeSheet() {
    if (!sheet) return;
    document.body.classList.remove('qai-sheet-active');
    if (sheet) sheet.setAttribute('aria-hidden', 'true');
    // Esperar a que termine la animación antes de mover el panel de vuelta
    setTimeout(restorePanelFromSheet, 320);
  }

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;
  }

  function toggleFromTrigger(trigger) {
    var wrapper = trigger.closest('.card-wrapper');
    if (!wrapper) return;
    if (wrapper.classList.contains('is-quick-add-open')) {
      closeSheet();
    } else {
      openSheet(trigger);
    }
  }

  /* ─── Add to cart (replica exacta de product-form.js del theme) ────────── */
  function getCartTarget() {
    // Mismo orden que product-form.js: cart-notification primero, luego cart-drawer
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function addToCart(button) {
    // Guard atómico: si ya hay un add en curso para ESTE botón, salir.
    if (button.dataset.qaiBusy === '1') return;
    button.dataset.qaiBusy = '1';

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
      delete button.dataset.qaiBusy;
      return;
    }

    var cart = getCartTarget();

    // Feedback visual INMEDIATO (sin esperar al fetch)
    button.classList.add('is-loading');
    button.setAttribute('aria-disabled', 'true');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart) {
      var sectionIds = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      formData.append('sections', sectionIds);
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    var config = {
      method: 'POST',
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    };

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    function release() {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-disabled');
      delete button.dataset.qaiBusy;
    }

    // La API de carrito de Shopify aplica rate-limit (429/430) y devuelve una
    // página HTML en vez de JSON. Si parseamos a ciegas, response.json() peta y
    // el añadido falla en silencio. Reintentamos con backoff antes de rendirnos.
    var MAX_ATTEMPTS = 3;

    function attemptFetch(attempt) {
      return fetch(addUrl, config).then(function (response) {
        var contentType = response.headers.get('content-type') || '';
        var isJson = contentType.indexOf('application/json') !== -1;

        // Throttle / respuesta no-JSON → reintentar con espera creciente
        if (!response.ok && !isJson) {
          if (attempt < MAX_ATTEMPTS) {
            return new Promise(function (resolve) {
              setTimeout(function () { resolve(attemptFetch(attempt + 1)); }, 300 * attempt);
            });
          }
          var throttleError = new Error('cart_throttled');
          throttleError.throttled = true;
          throw throttleError;
        }

        return response.json(); // a partir de aquí, JSON garantizado
      });
    }

    attemptFetch(1)
      .then(function (response) {
        if (response.status) {
          release();
          alert(response.description || response.message || 'No se pudo añadir al carrito');
          return;
        }
        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        // Cerrar el sheet (mobile) — primero devolvemos el panel a su card
        if (document.body.classList.contains('qai-sheet-active')) {
          closeSheet();
        }

        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);

        release();
        button.classList.add('is-added');
        setTimeout(function () { button.classList.remove('is-added'); }, 1000);
      })
      .catch(function (err) {
        release();
        if (err && err.throttled) {
          alert('Hay mucho tráfico ahora mismo. Espera unos segundos y vuelve a intentarlo.');
        } else {
          console.error('[quick-add-inline] error:', err);
        }
      });
  }

  /* ─── Reconstrucción de tallas por color (tarjetas con swatches) ───────── */
  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Reconstruye los botones de talla de un panel para el color indicado, usando
  // el JSON embebido. Replica exactamente el markup del server-render, de forma
  // que la talla añadida corresponda SIEMPRE al color seleccionado.
  function rebuildPanelSizes(panel, colorName) {
    if (!panel) return;
    var dataEl = panel.querySelector('.quick-add-inline__data');
    var sizesWrap = panel.querySelector('.quick-add-inline__sizes');
    if (!dataEl || !sizesWrap) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.variants || !data.sizes) return;

    var soldOut = data.soldOut || '';
    var html = '';
    data.sizes.forEach(function (size) {
      var match = null;
      var matchAvailable = false;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        // Color y talla se leen por posicion (id, color, talla, available) y no
        // por nombre: el traductor de la tienda cambia "size" por "Tamaño" en ES.
        var vals = Object.keys(v).map(function (k) { return v[k]; });
        if (vals[1] !== colorName) continue;
        if (vals[2] !== size) continue;
        if (v.available && !matchAvailable) {
          match = v;
          matchAvailable = true;
        } else if (!match) {
          match = v;
        }
      }
      if (!match) return; // talla inexistente en este color → no se pinta
      var unavailable = !match.available;
      var sEsc = escapeHtml(size);
      html += '<button type="button" class="quick-add-inline__size'
        + (unavailable ? ' quick-add-inline__size--unavailable' : '')
        + '" data-variant-id="' + match.id + '"'
        + ' data-size="' + sEsc + '"'
        + ' aria-label="' + sEsc + (unavailable ? ' (' + escapeHtml(soldOut) + ')' : '') + '"'
        + (unavailable ? ' disabled aria-disabled="true"' : '')
        + '>' + sEsc + '</button>';
    });
    sizesWrap.innerHTML = html;
  }

  // Localiza el panel de una card (aunque esté movido al bottom-sheet en móvil)
  // y reconstruye sus tallas para el color del swatch pulsado.
  function rebuildForCard(wrapper, colorName) {
    if (!wrapper || !colorName) return;
    var panel = wrapper.querySelector('.quick-add-inline');
    if (!panel) {
      var sheetEl = document.getElementById('qai-sheet');
      if (sheetEl && wrapper.id) {
        panel = sheetEl.querySelector('.quick-add-inline[data-product-id="' + wrapper.id + '"]');
      }
    }
    rebuildPanelSizes(panel, colorName);
  }

  /* ─── Init ─────────────────────────────────────────────────────────────── */
  function init() {
    repositionWithin(document);
    document.body.classList.add('qai-inited');

    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1 && (n.classList && (n.classList.contains('grid__item') || (n.querySelector && n.querySelector('.quick-add-inline'))))) {
            repositionWithin(n);
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // Al salir el cursor del card-wrapper, quitamos foco a cualquier botón de
    // talla activo dentro. Sin esto, :focus-within mantenía la banda visible
    // aunque el cursor ya estuviera en otro producto.
    document.addEventListener('mouseleave', function (ev) {
      var wrapper = ev.target.closest && ev.target.closest('.card-wrapper');
      if (!wrapper) return;
      var focused = wrapper.querySelector('.quick-add-inline__size:focus, .quick-add-inline__trigger:focus');
      if (focused) focused.blur();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ─── Event delegation ─────────────────────────────────────────────────── */
  function handleOutsideTap(ev) {
    if (!document.body.classList.contains('qai-sheet-active')) return;
    // Si el target NO está dentro del sheet ni es un trigger, cerrar.
    if (ev.target.closest('#qai-sheet')) return;
    if (ev.target.closest('.quick-add-inline__trigger')) return;
    closeSheet();
  }

  document.addEventListener('click', function (ev) {
    var trigger = ev.target.closest('.quick-add-inline__trigger');
    if (trigger) {
      ev.preventDefault();
      ev.stopPropagation();
      if (isMobileViewport()) {
        toggleFromTrigger(trigger);
      }
      return;
    }

    var sizeBtn = ev.target.closest('.quick-add-inline__size');
    if (sizeBtn) {
      if (sizeBtn.classList.contains('quick-add-inline__size--unavailable')) return;
      ev.preventDefault();
      ev.stopPropagation();
      addToCart(sizeBtn);
      return;
    }

    // Cambio de color vía swatch → reconstruir las tallas del quick-add para
    // ese color. NO frenamos la propagación: VariantMedia (global.js) sigue
    // recibiendo el evento para cambiar la imagen de la card.
    var swatch = ev.target.closest('.swatch-color');
    if (swatch) {
      var swatchCard = swatch.closest('.card-wrapper');
      if (swatchCard) {
        var swatchColor = swatch.getAttribute('title');
        if (swatchColor) rebuildForCard(swatchCard, swatchColor);
      }
      return;
    }

    // Si el sheet está abierto y el tap es fuera del sheet → cerrar
    handleOutsideTap(ev);
  }, true);

  // Fallback para mobile donde el click puede no dispararse tras un touch
  document.addEventListener('touchend', function (ev) {
    if (!document.body.classList.contains('qai-sheet-active')) return;
    if (ev.target.closest('#qai-sheet')) return;
    if (ev.target.closest('.quick-add-inline__trigger')) return;
    closeSheet();
  });

  // Escape cierra el sheet
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && document.body.classList.contains('qai-sheet-active')) {
      closeSheet();
    }
  });
})();
